var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading === true)?_c('clip-loader',{class:_vm.classLoader,attrs:{"size":_vm.size,"color":_vm.color}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }